import { createLucideIcon } from './lucideIcon'

export const Minimize2 = createLucideIcon(
  'Minimize2',
  <>
    <path d="m14 10 7-7" />
    <path d="M20 10h-6V4" />
    <path d="m3 21 7-7" />
    <path d="M4 14h6v6" />
  </>
)
